import { Text } from '@shared/components/Text';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';
import { MBBaseChatBanner } from './base';

interface MBMeChatBannerProps {
  user: API.ShortUserFragment;
  channel: API.ChannelChatThreadFragment;
}

export function MBMeChatBanner({ user, channel }: MBMeChatBannerProps) {
  return (
    <MBBaseChatBanner title={channel.name} subtitle={`@${user.username}`} channel={channel}>
      <Text color={Colors.v2.greenSecondary90}>{i18n('chat.banner.yourSpace')}</Text>
    </MBBaseChatBanner>
  );
}
